export const types = {
  SET_CONTACTS: "setContacts",
  SET_CONTACTS_LOADING: "setLoading",
  SET_REFRESH_CONTACTS_STATUS: "setRefreshContactsStatus"
};
